import { render } from "./BasicLoading.vue?vue&type=template&id=ed53907c&scoped=true"
const script = {}

import "./BasicLoading.vue?vue&type=style&index=0&id=ed53907c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed53907c"]])

export default __exports__